import React from 'react'
import unkownroute from "../assets/Company/404Page.svg"
export default function Notfound() {
  return (
    <div style={{display:'flex',justifyContent:"center",alignItems:"center",height:"100vh"}}>
      <img src={unkownroute} width={280} height={280}/>
    </div>
  )
}
